
import { generateShortUrl } from '@api/company.api';
import { useState, useEffect } from 'react';
import './index.css'
//@ts-ignore
import QRCode from 'qrcode.react';
export default function JoinCompany(props: any) {
  const [qrUrl, setQrUrl] = useState('');
  useEffect(() => {
    const query = new URLSearchParams(props.location.search);
    const companyId = query.get('companyId') || "";
    const personId = query.get('personId') || '';
    const shareLink = getShareLink({ companyId, personId });
    initInfo(shareLink);
  })
  function getShareLink(params: { companyId: string, personId: string }): string {
    const { companyId, personId } = params
    let salesId = companyId + '_' + personId;
    let path = 'company/profile/' + companyId + '?&sales=' + salesId + '&showSalesCard=Y';
    let link = getOwnerUrl(path);
    return link;
  };

  function getOwnerUrl(path: string): string {
    if (!path)
      return '';
    var first = path.slice(0, 1);
    var url = process.env.REACT_APP_OWNER_HOST;
    switch (first) {
      case '#':
        url = url + path;
        break;
      case '/':
        url = url + '#' + path;
        break;
      default:
        url = url + '#/' + path;
        break;

    }
    return url;
  };
  async function initInfo(url: string) {
    const res = await generateShortUrl({ url: encodeURIComponent(url), type: 'no_prefix' });
    setQrUrl(res.data.shortUrl);
    transferCanvasToImg();
  }
  function transferCanvasToImg() {

    let canvasImg = document.getElementsByTagName('canvas')[0];
    let image = new Image();


    image.src = canvasImg?.toDataURL("image/png");
    let alink = document.createElement("img");
    alink.className = 'qrcode';
    alink.src = image.src;
    //@ts-ignore
    canvasImg?.parentNode.replaceChild(alink, canvasImg)
  }
  return (
    <div className="background ng-scope">
      <div className="qr-code-card">
        {qrUrl ? <div id="myQRcode" className="qr-image">
          <QRCode
            value={qrUrl}// 生成二维码的内容
            size={260} // 二维码的大小
            fgColor="#000000" // 二维码的颜色
          />
        </div> : <div className="qrcode" />}
        <span className="desc">长按二维码保存到手机或发送给朋友</span>

        <div className="desc-more">
          <span className="text-1"> 还可复制链接：</span>
          <span className="text-2">{decodeURIComponent(qrUrl)}</span>
          <span>粘贴到微信、朋友圈及其他推广平台使用</span>
        </div>

      </div>
    </div>
  )
}